const defaultTimezone = 'Europe/Berlin';

export default defaultTimezone;
